import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './products.css';
import { FiDownload, FiArrowRight } from 'react-icons/fi';
import HexagonBackground from './HexagonBackground';
import kiaImg from '../../assets/products/kia-img.png';
import nissanImmoImg from '../../assets/products/nissan-img.png';
import nissanSystemImg from '../../assets/products/nissan-system.png';
import delphiImg from '../../assets/products/delphi-img.png';
import dodgeImg from '../../assets/products/dodge-img.png';

const softwareProducts = [
  {
    id: 'nissan-immo-off',
    title: 'Nissan-Immo-Off',
    description: 'Professional solution for Nissan Immobilizer bypass. Supports multiple ECU models with one-click processing.',
    version: 'v2.1.0',
    image: nissanImmoImg,
  },
  {
    id: 'kia-hyundai-system-off',
    title: 'Kia-Hyundai-System-Off',
    description: 'Advanced tool for Kia and Hyundai system management. Easy to use interface for disabling various engine systems.',
    version: 'v1.5.4',
    image: kiaImg,
  },
  {
    id: 'nissan-dtc-system-off',
    title: 'Nissan-DTC-System-Off',
    description: 'Specialized software for removing specific Diagnostic Trouble Codes from Nissan engine control units.',
    version: 'v3.0.2',
    image: nissanSystemImg,
  },
  {
    id: 'toyota-delphi-system-off',
    title: 'Toyota-Delphi-System-Off',
    description: 'Advanced Delphi ECU utility for Toyota platforms with IMMO OFF and selected DTC OFF support for workshop use.',
    version: 'v1.0.0',
    image: delphiImg,
  },
  {
    id: 'dodge-file-unlock',
    title: 'Dodge File Unlock',
    description: 'File unlock utility — project landing page for Dodge ECUs (external site).',
    version: 'v1.0.0 (demo)',
    image: dodgeImg,
  },
];

const Products = () => (
  <div className="gpt3__products section__padding" id="products">
    <HexagonBackground />
    <motion.div
      className="gpt3__products-heading"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8 }}
    >
      <h1 className="gradient__text">Premium Software Solutions</h1>
      <p>High-performance tools for professional automotive tuning and system management.</p>
    </motion.div>

    <motion.div
      className="gpt3__products-container"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      variants={{
        visible: {
          transition: {
            staggerChildren: 0.2
          }
        }
      }}
    >
      {softwareProducts.map((product, index) => (
        <motion.div
          className="gpt3__products-container_card"
          key={index}
          variants={{
            hidden: { opacity: 0, y: 20 },
            visible: { opacity: 1, y: 0 }
          }}
        >
          <div className="gpt3__products-container_card-image">
            <img src={product.image} alt={`${product.title} Professional ECU Software`} loading="lazy" />
          </div>
          <div className="gpt3__products-container_card-content">
            <span className="version_tag">{product.version}</span>
            <h3>{product.title}</h3>
            <p>{product.description}</p>
          </div>
          <div className="gpt3__products-container_card-actions">
            <Link to={`/product/${product.id}`} className="gpt3__products-container_card-detail-link">
              View Details <FiArrowRight />
            </Link>
            <div className="gpt3__products-container_card-button">
              <a href="https://wa.me/966590707424" target="_blank" rel="noreferrer">
                <button type="button">
                  <FiDownload /> Download
                </button>
              </a>
            </div>
          </div>
        </motion.div>
      ))}
    </motion.div>
  </div>
);

export default Products;
